import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7519a5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "registry container-fluid bg-admin p-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-auto sticky-top pe-0 shadow-sm" }
const _hoisted_4 = {
  class: "navbar d-flex flex-row flex-xl-column flex-nowrap bg-admin border-end border-green border-2 h-100 sticky-top p-0",
  role: "navigation",
  id: "sideBar"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "bi bi-list text-white fs-3" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "nav nav-pills nav-flush flex-row flex-xl-column flex-nowrap justify-content-around align-items-center w-100 mb-auto" }
const _hoisted_8 = ["onClick", "id"]
const _hoisted_9 = { class: "d-inline-flex align-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "m-0"
}
const _hoisted_11 = { class: "col-md p-5 min-vh-100" }
const _hoisted_12 = { class: "text-start text-white fw-bold pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Registration = _resolveComponent("Registration")!
  const _component_ManageUsers = _resolveComponent("ManageUsers")!
  const _component_UserReports = _resolveComponent("UserReports")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "navbar-toggler align-self-start d-none d-xl-block border-0 my-3 mx-3",
            type: "button",
            "aria-label": "Toggle Sidebar",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
            ref: "sidebarToggle"
          }, _hoisted_6, 512),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `${tab.tab.toLowerCase()}`,
                class: _normalizeClass(["nav-item h-100 w-100", _ctx.show ? 'text-start' : ''])
              }, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.switchTab(tab.tab)),
                  id: `${tab.tab.toLowerCase()}Tab`,
                  class: _normalizeClass(["nav-link link-white py-3 px-4 w-100 rounded-0", _ctx.activeTab === tab.tab ? 'active' : '']),
                  role: "button"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["bi text-white fs-2", [tab.icon, _ctx.show ? 'me-3' : '']])
                    }, null, 2),
                    (_ctx.show)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(tab.text), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_8)
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.activeTab), 1),
        (_ctx.activeTab === 'Registration')
          ? (_openBlock(), _createBlock(_component_Registration, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'Members')
          ? (_openBlock(), _createBlock(_component_ManageUsers, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'Reports')
          ? (_openBlock(), _createBlock(_component_UserReports, { key: 2 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}